import { VideoInPageComponent } from './video-in-page.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ VideoInPageComponent: VideoInPageComponent });
